import dayjs from "dayjs";
import React, { useRef } from 'react'
import { Autocomplete, Box, Checkbox, TextField } from '@mui/material'
import { GridEditSingleSelectCell, useGridApiContext } from '@mui/x-data-grid-premium'
import { DatePicker, TimePicker } from '@mui/x-date-pickers-pro'
import { unstable_useEnhancedEffect as useEnhancedEffect } from '@mui/utils'
import CustomAutocomplete from "../../form/autocomplete/autocomplete";
import ColorSelect from '../../form/colorSelect/colorSelect'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'

const EditableMuiDataGridCustomFields = (props) => {
    const {
        type = 'text',
        params,
        name,
        onChange,
        options,
        onChangeInput = () => {},
        otherInputParams = {},
        labelKey
    } = props
    const { id, value, field, hasFocus } = params
    const apiRef = useGridApiContext()
    const inputRef = useRef()
    useEnhancedEffect(() => {
        if (hasFocus) {
            inputRef.current?.focus()
        }
    }, [hasFocus])
    
    let input = null
    switch (type) {
        case 'singleAutocomplete': // TODO::Σταδιακά να καταργηθεί σαν case και αντικατασταθούν οι χρήσεις του με το 'customAutocomplete' case
            input = (
                <Autocomplete
                    sx={{ width: 400, overflow: 'auto' }}
                    options={Array.isArray(options) ? options : []}
                    value={value}
                    onChange={(event, newValue) => {
                        if (onChange) onChange({ newValue, apiRef, params })
                        apiRef.current.setEditCellValue({ id, field, value: newValue?.id ? newValue?.id : '' })
                    }}
                    isOptionEqualToValue={(opt, val) => {
                        return opt.id === val || !val
                    }}
                    getOptionLabel={option => {
                        return !option ? '' : typeof option === 'string' ? options.find(opt => opt.id === option)?.Description : option?.Description
                    }}
                    renderInput={(params) => <TextField {...params}
                                                        onChange={onChangeInput}
                                                        inputRef={inputRef}
                    />}
                    {...otherInputParams}
                    renderOption={(props, option) => {
                        const {key, ...other} = props
                        return <li key={key }{...other}>{option.Description}</li>
                    }}
                />
            )
            break
        case 'autocomplete': // TODO::Σταδιακά να καταργηθεί σαν case και αντικατασταθούν οι χρήσεις του με το 'customAutocomplete' case
            input = (
                <Autocomplete
                    sx={{ minWidth: 450, overflow: 'auto' }}
                    multiple
                    disableCloseOnSelect
                    options={Array.isArray(options) ? options : []}
                    value={Array.isArray(value) ? value : []}
                    onChange={(event, newValue) => {
                        if (onChange) onChange({ newValue, apiRef, params })
                        apiRef.current.setEditCellValue({ id, field, value: newValue })
                    }}
                    isOptionEqualToValue={(opt, val) => {
                        return opt.value === val.value || !val
                    }}
                    renderInput={(params) => <TextField {...params} inputRef={inputRef}/>}
                    {...otherInputParams}
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                            <Checkbox
                                icon={<CheckBoxOutlineBlankIcon fontSize="small"/>}
                                checkedIcon={<CheckBoxIcon fontSize="small"/>}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option.label}
                        </li>
                    )}
                />
            )
            break
        case 'customAutocomplete':
            input = (
                <CustomAutocomplete
                    identifier={otherInputParams?.identifier || 'id'}
                    value={value}
                    onChange={(event, newValue) => {
                        if (onChange) onChange({ newValue, apiRef, params })
                        apiRef.current.setEditCellValue({ id, field, value: newValue?.inputValue ? newValue.inputValue : newValue })
                    }}
                    options={Array.isArray(options) ? options : []}
                    labelKey={labelKey}
                    onInputChange={onChangeInput}
                    inputRef={inputRef}
                    {...otherInputParams}
                />
            )
            break
        case 'datePicker':
            const dateValue = value ? dayjs(value) : null
            input = (
                <DatePicker
                    inputRef={inputRef}
                    name={name}
                    value={dateValue}
                    onChange={(newValue) => {
                        if (onChange) onChange({ newValue, apiRef, params })
                        apiRef.current.setEditCellValue({ id, field, value: newValue })
                    }}
                    slots={{ textField: TextField }}
                    slotProps={{
                        textField: {
                            inputRef,
                            ...otherInputParams,
                        },
                    }}
                    {...otherInputParams}
                />
            )
            break
        case 'timePicker':
            input = (
                <TimePicker
                    inputRef={inputRef}
                    name={name}
                    value={value}
                    onChange={(newValue) => {
                        if (onChange) onChange({ newValue, apiRef, params })
                        apiRef.current.setEditCellValue({ id, field, value: newValue })
                    }}
                    renderInput={(props) => <TextField {...props} />}
                    {...otherInputParams}
                />
            )
            break
        case 'colorPicker':
            input = (
                <ColorSelect
                    color={value}
                    onColorChange={(newValue) => {
                        if (onChange) onChange({ newValue, apiRef, params })
                        apiRef.current.setEditCellValue({ id, field, value: newValue })
                    }}
                />
            )
            break
        case 'gridSelect':
            input = (
                <GridEditSingleSelectCell
                    onValueChange={(evt, newValue) => {
                        if (onChange) onChange({ evt, newValue, apiRef, params })
                        apiRef.current.setEditCellValue({ id, field, value: newValue })
                    }}
                    {...params}
                />
            )
            break
        default:
            input = (
                <TextField
                    inputRef={inputRef}
                    name={name}
                    value={value}
                    onChange={(evt) => {
                        if (onChange) onChange({ evt, newValue: evt.target.value, apiRef, params })
                        apiRef.current.setEditCellValue({ id, field, value: evt.target.value })
                    }}
                    variant="standard"
                    fullWidth
                    type={type}
                    {...otherInputParams}
                />
            )
    }
    return (
        <Box sx={{ display: 'flex', width: '100%', alignItems: 'center' }}>
            {input}
        </Box>
    )
}

export default EditableMuiDataGridCustomFields